import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const IndeterminateCheckboxIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <circle cx="12" cy="12" r="12" fill="#2196F3" />
            <rect x="5" y="11" width="14" height="2" fill="white" />
        </SvgIcon>
    );
};
